export interface ImageDimension {
  width: number;
  height: number;
}

export default function ImageComponent({
  currentBlockId,
  src,
  imageAlt = '',
  opacity = 100,
  style,
  dimension,
}: {
  currentBlockId: string;
  src: string;
  imageAlt: string | undefined;
  opacity: number | undefined;
  style: React.CSSProperties;
  dimension: ImageDimension;
}) {
  const customImageAlt = imageAlt ? imageAlt : `image-${currentBlockId}`;

  if (src === '') {
    return null;
  }

  return (
    <img
      key={`image-${currentBlockId}`}
      data-testid={`image-${currentBlockId}`}
      src={src}
      alt={customImageAlt}
      className="grid_image_style"
      draggable={false}
      style={{ ...style, opacity: `${opacity}%`, width: `${dimension.width}px`, height: `${dimension.height}px` }}
    />
  );
}
